import { render, staticRenderFns } from "./ProductsListComponent.html?vue&type=template&id=75830a08&"
import script from "./ProductsListComponent.js?vue&type=script&lang=js&"
export * from "./ProductsListComponent.js?vue&type=script&lang=js&"
import style0 from "./ProductsListComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports